module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2000-04-06/5-0b20934e0444ece65263157f405ba1c1.jpg";